import React, { createContext, useState } from "react";
import { Alert, Snackbar, useMediaQuery, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import Slide from "@mui/material/Slide";

export const SnackbarContext = createContext(null);

export default function SnackbarProvider({ children }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  /* ✅ slide transition with direction */
  const SlideTransition = (props) => (
    <Slide
      {...props}
      direction={isMobile ? "down" : "up"}
    />
  );

  const showSnackbar = (message, severity = "success") => {
    // reset first to allow re-trigger
    setSnackbar((prev) => ({ ...prev, open: false }));

    setTimeout(() => {
      setSnackbar({
        open: true,
        message,
        severity,
      });
    }, 50);
  };

  const handleClose = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3200}
        onClose={handleClose}
        TransitionComponent={SlideTransition}
        anchorOrigin={
          isMobile
            ? { vertical: "top", horizontal: "center" }
            : { vertical: "bottom", horizontal: "left" }
        }
        sx={{
          zIndex: 1800,

          /* 📱 mobile */
          ...(isMobile && {
            top: 72,
            left: 0,
            right: 0,
            px: 1.5,
          }),

          /* 💻 desktop */
          ...(!isMobile && {
            bottom: 24,
            left: 24,
          }),
        }}
      >
        <Alert
          severity={snackbar.severity}
          variant="filled"
          sx={{
            borderRadius: 4,
            border: `1px solid ${alpha("#ffffff", 0.18)}`,
            boxShadow: "0 22px 50px rgba(15, 23, 42, 0.18)",
            width: isMobile ? "100%" : "auto",
            maxWidth: isMobile ? "100%" : 420,
            alignItems: "center",
            "& .MuiAlert-message": {
              fontWeight: 600,
            },
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
}
